// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__2C1LB","col":"Table_col__2Pkdu","fulfillmentStatus":"Table_fulfillmentStatus__2dLcn","emailCol":"Table_emailCol__1UzHE"};